module.exports = __webpack_public_path__ + "static/img/man-title.9754baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/man-title.png
// module id = 136
// module chunks = 0